
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-password",
      function () {
        return require("private-next-pages/new-password.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-password"])
      });
    }
  